<div>
    <mat-spinner [diameter]="20"></mat-spinner>
    <span>Loading page...</span>
</div>
